import NextLink from 'next/link'
import clsx from 'clsx'

import { List, ListItem } from '@wartek-id/list'
import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text-v1'

import {
  PENGELOLAAN_KINERJA_KS_PATH,
  PENGELOLAAN_KINERJA_PS_PATH,
} from 'app/KinerjaKSPage/constants'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

import type { FC } from 'react'

function Link({ href, children, ...props }) {
  return (
    <NextLink href={href} passHref>
      <a {...props}>{children}</a>
    </NextLink>
  )
}

type NavbarMenu =
  | 'homepage'
  | 'history'
  | 'pengelolaan-kinerja-saya' // For Kepala Sekolah Definitif and/or Plt Kepala Sekolah
  | 'pengelolaan-kinerja-ps' // For Pengawas Sekolah

interface Menu {
  name: string
  href: string
  icon?: string
  menu: NavbarMenu
}

interface NavbarProps {
  sticky?: boolean
  className?: string
  activeMenu: NavbarMenu
  showKinerjaAnda?: boolean
  showKinerjaPs?: boolean
}

const Navbar: FC<NavbarProps> = ({
  sticky = false,
  className = '',
  activeMenu,
  showKinerjaAnda = false,
  showKinerjaPs = false,
}) => {
  const { isPengawasSekolah, isLoading } = useRoleContext()

  const MENUS: Array<Menu> = [
    {
      name: 'Beranda',
      href: '/pengelolaan-kinerja',
      icon: 'home',
      menu: 'homepage',
    },
    ...(showKinerjaAnda
      ? ([
          {
            name: 'Pengelolaan Kinerja Anda',
            href: PENGELOLAAN_KINERJA_KS_PATH,
            menu: 'pengelolaan-kinerja-saya',
          },
        ] as Array<Menu>)
      : []),
    ...(showKinerjaPs && !isLoading && isPengawasSekolah
      ? ([
          {
            name: 'Pengawas Sekolah',
            href: PENGELOLAAN_KINERJA_PS_PATH,
            menu: 'pengelolaan-kinerja-ps',
          },
        ] as Array<Menu>)
      : []),
    // {
    //   name: 'Riwayat',
    //   href: '/pengelolaan-kinerja/riwayat',
    //   icon: 'people',
    //   menu: 'history',
    // },
  ]

  return (
    <nav
      className={clsx(
        'p-5 bg-white !w-80 flex-none self-stretch',
        sticky && 'fixed top-[4.25rem] left-0 bottom-0 z-10',
        className
      )}
      style={{
        boxShadow: 'var(--elevation-01)',
      }}
    >
      <List type="menu">
        {MENUS.map((menu) => {
          const isActive = activeMenu === menu.menu

          return (
            <ListItem
              key={menu.menu}
              as={!isActive ? Link : undefined}
              href={!isActive ? menu.href : undefined}
              iconLeft={
                <Icon as="i" color="default" fontSize="default">
                  {menu.icon}
                </Icon>
              }
            >
              <Text variant={isActive ? 'body-bold' : 'body'}>{menu.name}</Text>
            </ListItem>
          )
        })}
      </List>
    </nav>
  )
}

export default Navbar
